// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.6.8_@swc+helpers@0.5.23__webpack@5.108.4_@swc+core@1.15_b0345aabf8a2fe8f5423f3b3e9febcd5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.6.8_@swc+helpers@0.5.23__webpack@5.108.4_@swc+core@1.15_b0345aabf8a2fe8f5423f3b3e9febcd5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pg7yhRjb__ProductName__skeleton-module__container___XII653kbVEEdrkSB {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
}

.pg7yhRjb__ProductName__skeleton-module__title___MyBu_WZPSg0vtFyk {
    width: 90%;
    height: 1.75rem;
}

.pg7yhRjb__ProductName__skeleton-module__subtitle___ZpsGkrTvPsDDNDkV {
    width: 65%;
    height: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/modules/productInfo/components/ProductName/skeleton.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1.5rem;\n    margin-bottom: 1.5rem;\n}\n\n.title {\n    width: 90%;\n    height: 1.75rem;\n}\n\n.subtitle {\n    width: 65%;\n    height: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export var container = `pg7yhRjb__ProductName__skeleton-module__container___XII653kbVEEdrkSB`;
export var title = `pg7yhRjb__ProductName__skeleton-module__title___MyBu_WZPSg0vtFyk`;
export var subtitle = `pg7yhRjb__ProductName__skeleton-module__subtitle___ZpsGkrTvPsDDNDkV`;
export default ___CSS_LOADER_EXPORT___;
